import { Step } from 'react-joyride';
import TourStepLifeCycle from 'app/tour/TourStepLifeCycle';
import React from 'react';
import AppTour from 'app/tour/AppTour';

export const TourContext = React.createContext<AppTour | undefined>(undefined);
export interface TourStepRaw extends Step {
    lifeCycle?: TourStepLifeCycle;
    waitForSelector?: boolean;
    target: string;
}

export interface TourStep extends TourStepRaw {
    lifeCycle: TourStepLifeCycle;
    waitForSelector: boolean;
}

export interface TourStatus {
    isActive: boolean;
    stepIndex: number;
    isStepTransition: boolean;
    steps: Array<TourStep>;
}
